import(/* webpackMode: "eager", webpackExports: ["QuarkNoResult"] */ "/vercel/path0/packages/features/quark/src/screens/app-no-result/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nClientProvider"] */ "/vercel/path0/packages/shared/i18n/src/provider/i18n-client.provider.tsx");
